import { render, staticRenderFns } from "./TableLoadItemComponent.vue?vue&type=template&id=52236f1a&"
import script from "./TableLoadItemComponent.vue?vue&type=script&lang=js&"
export * from "./TableLoadItemComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports